import { axiosBaseURL } from "../../../http";
import SessionStore from "../../../lazyLoaders/session_lazy";

export const login = (uname, pass) => {
    return axiosBaseURL.post("user_api/login/", {
        username: uname,
        password: pass,
    }).then(function (response) {
        SessionStore.setToken(response.data.token);
        SessionStore.setData(response.data.profile);
        return true;
    }).catch(function (error) {
        return false;
    });
}

export const signUp = (data) => {
    return axiosBaseURL.post('user_api/register/', data)
        .then((response) => {
            return login(response.data.username, data.password).then(() => true);
        })
        .catch((error) => {
            console.log(error)
            return false;
        });
}